// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"r2-z","displaySixCardTiles":"s2-z"};